import { Stream } from '@smart-tv/components/player/types';
import { VisualOnStream } from '../types';
import { APP_VERSION } from '@smart-tv/utils/api-constants';

const PLAYER_VERSION = process.env.PLAYER_VERSION || '';

export const formatVisualOnStream = (stream: Stream, uri: string): VisualOnStream => {
  if (stream.drmEngine === 'fairplay') {
    return {
      links: [
        {
          uri,
          type: 'hls',
          drm: {
            fairplay: {
              laUrl: stream.licenseServerUrl,
              certificateUrl: stream.licenseCertificateUrl
            }
          }
        }
      ],
      advanced: {
        anlyticsCustomData: {
          cd1: APP_VERSION,
          cd2: PLAYER_VERSION
        }
      }
    };
  }
  return {
    links: [
      {
        uri,
        type: 'dash',
        drm: {
          widevine: {
            laUrl: stream.licenseServerUrl
          }
        }
      }
    ],
    advanced: {
      anlyticsCustomData: {
        cd1: APP_VERSION,
        cd2: PLAYER_VERSION
      }
    }
  };
};

export default formatVisualOnStream;
